
import red from '@material-ui/core/colors/red';

export default (theme) => ({
  root: { width: '100%' },
  loadingContainer: {
    margin: 'auto',
    marginTop: '1rem',
    display: 'block',
    width: '3rem',
  },
  card: {
    background: '#FFFFFF',
    position: 'relative',
    zIndex: 3,
    borderRadius: '6px',
    boxShadow: '0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)',
  },
  cardBody: {
    width: '100%',
    overflowX: 'auto',
  },
  chipPaid: {
    color: 'white',
    fontWeight: 'bold',
  },
  chipNotPaid: {
    backgroundColor: red[400],
    color: 'white',
    fontWeight: 'bold',
  },
  button: { margin: theme.spacing(1) },
  errorButton: {
    color: red[400],
    margin: theme.spacing(1),
  },
  buttonIcon: { margin: theme.spacing(1) },
  paperContainer: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    margin: theme.spacing(2),
    overflowX: 'auto',
  },
});
